import { MulticityFlightCard, type MulticityFlightCardProps } from './multicityFlightCard'

export { MulticityFlightCard }
export type { MulticityFlightCardProps }
export default MulticityFlightCard
